import { Component, OnInit } from "@angular/core";
import { CalendarModes, ColorFromId, LoaderService, Message } from "@stdoutsrl/design-kit";
import { BookingService } from "../../service/booking.service";
import { timetables } from "../../../assets/constants";
import { RestService } from "@stdoutsrl/design-kit";

@Component({
  selector: "app-operator-shifts",
  templateUrl: "./operator-shifts.component.html",
  styles: [],
  standalone: false,
})
export class OperatorShiftsComponent implements OnInit {
  constructor(
    private loader: LoaderService,
    private booking: BookingService,
    private message: Message,
    private rest: RestService,
    private randomColorById: ColorFromId
  ) {}
  specificSearchPhone = "";
  specificSearchSurname = "";
  specificSearchEmail = "";
  specificSearchName = "";
  searchedClient: any;
  mobileItems: any[] = [{ label: "Prodotto", value: "item.name" }];
  showModalSearchClient = false;
  arrayPrenotations: any[] = [];
  currentEvent: any = {};
  selectStartDate: any = null;
  selectEndDate: any = null;
  timesheetStart = "2025-01-01";
  timesheetEnd = "2025-01-31";
  dateForApi = "";
  isCalendarWeekly = true;
  currentOperator: any = {id:-1,name:'Tutti'};
  mySalons: any[] = [];
  myOperators: any[] = [{id:'-1',name:'Tutti'}];
  myProducts: any[] = [];
  showModalBooking = false;
  modalDelete = false;
  isNewPrenotation = true;
  timetables = timetables;
  date = "2025-02-22";
  currentDate = new Date();
  changeSelectStart = true;
  suggestedTimeSlots = [];
  customers: any[] = [];
  showCalendar = true;
  currentEventSelected: any = {};
  isEditEvent = false;
  changeSelectEnd = false;
  changedSelectStart = false;
  addUser = false;
  currentSalon: any;
  ngOnInit(): void {
    const date = new Date();
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const dayFirst = firstDay.getDate().toString().padStart(2, "0");
    const monthFirst = (firstDay.getMonth() + 1).toString().padStart(2, "0");
    const yearFirst = firstDay.getFullYear();
    const dayLast = lastDay.getDate().toString().padStart(2, "0");
    const monthLast = (lastDay.getMonth() + 1).toString().padStart(2, "0");
    const yearLast = lastDay.getFullYear();
    this.timesheetStart = `${yearFirst}-${monthFirst}-${dayFirst}`;
    this.timesheetEnd = `${yearLast}-${monthLast}-${dayLast}`;
    this.getMySalons();
    this.getMyCompany();
    this.getMyCustomers();
  }

  inviteClient() {
    this.loader.on();
    let params = {
      firstName: this.specificSearchName,
      lastName: this.specificSearchSurname,
      phone: this.specificSearchPhone,
      email: this.specificSearchEmail,
    };
    this.rest.post("/booking/new_user", params).subscribe({
      next: (value: any) => {
        this.customers.push({
          label: this.specificSearchName + " " + this.specificSearchSurname,
          value: value.userId,
        });
        this.searchedClient = {
          firstName: this.specificSearchName,
          lastName: this.specificSearchSurname,
          phone: this.specificSearchPhone,
          email: this.specificSearchEmail,
          id: value.userId,
        };
        this.currentEventSelected.userId = value.userId;
        this.currentEvent.userId = value.userId;
        this.showModalSearchClient = false;
        this.loader.off(true);
      },
      error: (error) => {
        this.loader.off(true);
        if (error.status == 409) {
          this.message.showMessage('"Utente già registrato"', "error");
        }
      },
    });
  }

  sendReminderWhatapp(t: any) {
    const date = new Date(this.currentEventSelected?.startDate);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedDate = `${day}/${month}/${year} - ${hours}:${
      minutes < 10 ? "0" : ""
    }${minutes}`;

    let whatappMessage = `📢 Promemoria Appuntamento – ${this.currentEventSelected?.salon?.name}%0A%0ASalve,%0Ale ricordiamo che ha un appuntamento presso il  ${this.currentEventSelected?.salon?.name}, ${formattedDate}.%0A%0AIndirizzo:  ${this.currentEventSelected?.salon?.address}%0A📞 Per eventuali modifiche o conferma, può contattarci al  ${this.currentEventSelected?.salon?.phoneNumber} (anche su WhatsApp).%0A%0A✨ La aspettiamo per il suo trattamento! ✨%0A%0A${this.currentEventSelected?.salon?.name}`;
    window.open(
      `https://web.whatsapp.com/send?phone=${this.currentEventSelected?.user?.phone}&text=${whatappMessage}`
    );
  }

  getFormattedDate(myDate: Date) {
    const date = new Date(myDate);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
  }

  getMyCustomers() {
    this.rest.get("/user/customers?options={%22limit%22:500}").subscribe({
      next: (value: any) => {
        this.customers = [
          { value: null, label: "Fuori app" },
          ...value.data.map((client: any) => {
            return {
              label: client.firstName + " " + client.lastName,
              value: client.id,
            };
          }),
        ];
      },
    });
  }

  refreshCalendar() {
    this.showCalendar = false;
    setTimeout(() => {
      this.showCalendar = true;
    }, 0);
  }

  getClientsPrenotation() {
    this.booking.getUsersPrenotation().subscribe({
      next: (value) => {},
      error: (value) => {},
    });
  }

  getMySalons() {
    this.loader.on();
    this.booking.getMySalons().subscribe({
      next: (value: any) => {
        this.loader.off(true);
        this.mySalons = value;
        if (value[0]) {
          this.getTimeSheetSalon();
        } else {
          this.message.showMessage(
            "Prima di continuare devi creare almeno un salone",
            "error"
          );
        }
      },
      error: (value) => {
        this.loader.off(true);
      },
    });
  }

  getMyOperators(id: number) {
    this.loader.on();
    this.booking.getMyOperators(id).subscribe({
      next: (value: any) => {
        this.loader.off(true);
        this.myOperators = [{id:'-1',name:'Tutti'},...value.map((res: any) => {
          res.name = res.firstName + " " + res.lastName;
          return res;
        })];
      },
      error: (value) => {
        this.loader.off(true);
      },
    });
  }

  getSuggestedSlots() {
    // this.loader.on();
    // this.booking
    //   .getSuggestedSlots(
    //     this.currentOperator.id,
    //     this.dateForApi,
    //     this.dateForApi,
    //     this.currentEvent.itemId
    //   )
    //   .subscribe({
    //     next: (value: any) => {
    //       this.loader.off(true);
    //       if (value[0]?.slots) {
    //         this.suggestedTimeSlots = value[0].slots;
    //       } else {
    //         this.suggestedTimeSlots = [];
    //       }
    //     },
    //     error: (value) => {
    //       this.loader.off(true);
    //     },
    //   });
  }

  getMyProducts(id: number) {
    this.loader.on();
    this.booking.getMyProducts(id).subscribe({
      next: (value: any) => {
        this.loader.off(true);
        this.myProducts = value;
      },
      error: (value) => {
        this.loader.off(true);
      },
    });
  }

  getMyCompany() {
    this.loader.on();
    this.booking.getMyCompany().subscribe({
      next: (value: any) => {
        this.loader.off(true);
        this.getMyOperators(value[0].id);
        this.getMyProducts(value[0].id);
      },
      error: (value) => {
        this.loader.off(true);
      },
    });
  }

  deleteBooking() {
    this.modalDelete = false;
    this.loader.on();
    this.rest.delete(`/operator/shifts/${this.currentOperator.id}/${this.currentEvent.id}`).subscribe({
      next: () => {
        this.loader.off(true);
        this.calendarPrenotations();
      },
      error: (value) => {
        this.loader.off(true);
      },
    });
  }

  changeCustomer(event: any) {
    this.currentEvent.userId = event.value;
  }

  getMyCustomer(id: number) {
    let myClient = this.customers.find((client: any) => client.value === id);
    if (myClient) {
      this.currentEvent.userId = myClient.value;
      return myClient;
    } else {
      this.currentEvent.userId = null;
      return { value: null, label: "Fuori app" };
    }
  }

  manageCalendar() {
    let myEvent = JSON.parse(JSON.stringify(this.currentEvent));

    myEvent.operatorId = this.currentOperator.id;
    myEvent.startDate = new Date(myEvent.startDate);
    myEvent.endDate = new Date(myEvent.endDate ?? myEvent.dateEnd);
    myEvent.salonId = this.isNewPrenotation ? this.currentSalon.id : this.currentEvent.salonId;
    myEvent.status = "active"; //active, canceled, absent, on_hold

    if (myEvent.startDate >= myEvent.endDate) {
      this.message.showMessage(
        "La data di inizio non può essere superiore o uguale a quella di inizio",
        "error"
      );
    } else {
      this.showModalBooking = false;
      this.loader.on();
      let myFunction = this.isNewPrenotation
        ? this.booking.addCalendarShift(myEvent)
        : this.rest.patch(`/operator/shifts/${this.currentOperator.id}/${this.currentEvent.id}`,myEvent);
      myFunction.subscribe({
        next: () => {
          this.currentEvent = {};
          this.currentEventSelected = {};
          this.selectStartDate = null;
          this.selectEndDate = null;
          this.changeSelectEnd = false;
          this.changedSelectStart = false;
          this.suggestedTimeSlots = [];
          this.loader.off(true);
          this.calendarPrenotations();
        },
        error: (value) => {},
      });
    }
  }

  adjustDateSelect(event: any, name: string) {
    const [h, m] = event.label.split(":");
    const [day, month, year] = this.date
      .split("/")
      .map((part) => parseInt(part, 10));
    let newDate = new Date(year, month - 1, day, parseInt(h), parseInt(m));
    this.currentEvent[name] = newDate;
    // if (name == "startDate") {
    //   this.changeSelectEnd = false;
    //   let myProductDuration = this.myProducts.find(
    //     (product: any) => product.id == this.currentEvent.itemId
    //   )?.duration;
    //   let editedDate = new Date(
    //     new Date(newDate).setMinutes(
    //       new Date(newDate).getMinutes() + myProductDuration
    //     )
    //   );
    //   let adjustedDate =
    //     (editedDate.getHours() >= 10 ? "" : "0") +
    //     editedDate.getHours().toString() +
    //     ":" +
    //     (editedDate.getMinutes() >= 10 ? "" : "0") +
    //     editedDate.getMinutes().toString();
    //   let myElementForSelect = timetables.find(
    //     (timeTab: any) => timeTab?.label == adjustedDate
    //   );
    //   this.selectStartDate = event;
    //   this.selectEndDate = myElementForSelect;
    //   this.adjustDateSelect(myElementForSelect, "endDate");
    //   this.changeSelectEnd = true;
    //   this.changedSelectStart = true;
    // }
  }

  selectSuggestedSlot(slot: string) {
    this.changeSelectStart = false;
    this.selectStartDate = { value: slot, label: slot };
    this.changeSelectStart = true;

    this.adjustDateSelect({ value: slot, label: slot }, "startDate");
  }

  getTimeSheetSalon(event?: any) {
    if(event){
    this.currentOperator = event;}
    this.calendarPrenotations();
    this.getSalonTimeTables();
  }

  getSalonTimeTables() {
    // this.booking.
  }

  calendarPrenotations() {
    this.loader.on();
    this.rest
      .get(
        `/operator/shifts${this.currentOperator.id > - 1? ('/' + this.currentOperator.id) : ''}?start=${this.timesheetStart}&end=${this.timesheetEnd}`
      )
      .subscribe({
        next: (value: any) => {
          this.arrayPrenotations = !value
            ? []
            : value.map((event: any) => ({
                name: this.currentOperator.name,
                dateStart: event.startDate,
                dateEnd: event.endDate,
                completeEvent: event,
                bgColor: this.randomColorById.generateColorFromId(
                  event?.operator?.id +
                    event?.operator?.firstName +
                    event?.operator?.lastName +
                    event?.operator?.companyId
                ),
                ...event,
              }));
              this.loader.off(true);
        },
        error: (value) => {
          this.loader.off(true);
        }
      });
  }

  manageOperator(event: any) {
    this.currentEvent.operatorId = event.id;
  }

  manageProduct(event: any) {
    this.currentEvent.price = event.price;
    this.currentEvent.itemId = event.id;
    this.getSuggestedSlots();
  }

  calendarModes: CalendarModes = {
    daily: {
      active: false
    },
    weekly: {
      onStartScrollToH:7,
      active: true,
      weeklyShowHoursMode: 'daily',
      similarEventsFirstWFull:false,
      weeklyHours: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23
      ]
    },
    monthly: {
      active: true
    },
    annual: {
      active: false
    }
  }

  dateSelect(dayCalendar: any) {
    this.isEditEvent = false;
    const date = new Date(dayCalendar.date);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    this.dateForApi = `${year}-${month}-${day}`;
    this.currentEvent = {};
    this.showModalBooking = true;
    this.date = formattedDate;
    this.currentDate = date;
    if (this.myProducts[0]) {
      this.currentEvent.price = this.myProducts[0].price;
      this.currentEvent.itemId = this.myProducts[0].id;
      // this.getSuggestedSlots();
    } else {
      this.message.showMessage("Devi creare almeno un prodotto", "error");
    }
  }

  manageElementsEvent(event: any) {
    const date = new Date(event.startDate);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    this.date = formattedDate;

    this.currentEvent.price = this.currentEvent.price;
    this.currentEvent.operatorId = this.currentEvent.operator.id;
    this.selectStartDate = timetables.find((res: any) =>
      res.value.includes(
        new Date(this.currentEvent.startDate).getHours() +
          ":" +
          new Date(this.currentEvent.startDate).getMinutes()
      )
    );
    this.selectEndDate = timetables.find((res: any) =>
      res.value.includes(
        new Date(this.currentEvent.endDate).getHours() +
          ":" +
          new Date(this.currentEvent.endDate).getMinutes()
      )
    );
    this.getSuggestedSlots();
  }

  getEventTime(timestamp: number): string {
    const date = new Date(timestamp);
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  }

  getNewEventsWeek(event: any) {
    this.isCalendarWeekly = true;
    const firstDay = new Date(event.firstDate);
    const lastDay = new Date(event.lastDate);
    const dayFirst = firstDay.getDate().toString().padStart(2, "0");
    const monthFirst = (firstDay.getMonth() + 1).toString().padStart(2, "0");
    const yearFirst = firstDay.getFullYear();
    const dayLast = lastDay.getDate().toString().padStart(2, "0");
    const monthLast = (lastDay.getMonth() + 1).toString().padStart(2, "0");
    const yearLast = lastDay.getFullYear();
    this.timesheetStart = `${yearFirst}-${monthFirst}-${dayFirst}`;
    this.timesheetEnd = `${yearLast}-${monthLast}-${dayLast}`;
    this.calendarPrenotations();
  }

  getNewEventsMonth(event: any) {
    this.isCalendarWeekly = false;
    const date = new Date(event.firstDate);
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const dayFirst = firstDay.getDate().toString().padStart(2, "0");
    const monthFirst = (firstDay.getMonth() + 1).toString().padStart(2, "0");
    const yearFirst = firstDay.getFullYear();
    const dayLast = lastDay.getDate().toString().padStart(2, "0");
    const monthLast = (lastDay.getMonth() + 1).toString().padStart(2, "0");
    const yearLast = lastDay.getFullYear();
    this.timesheetStart = `${yearFirst}-${monthFirst}-${dayFirst}`;
    this.timesheetEnd = `${yearLast}-${monthLast}-${dayLast}`;
    this.calendarPrenotations();
  }
}
